var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { DropdownField, MenuItem } from '@one-thd/sui-atomic-components';
export var SortBy = function (props) {
    var pHRequest = props.pHRequest, setPHRequest = props.setPHRequest, handleClose = props.handleClose;
    return (React.createElement(DropdownField, { label: "Sort By", value: pHRequest.sortBy, onChange: function (event) {
            setPHRequest(function (prevState) {
                return __assign(__assign({}, prevState), { sortBy: event.target.value });
            });
            handleClose();
        }, fullWidth: true },
        React.createElement(MenuItem, { value: "salesDate" }, "Date"),
        React.createElement(MenuItem, { value: "orderNumber" }, "Order #"),
        React.createElement(MenuItem, { value: "POJobName" }, "PO/Job Name"),
        React.createElement(MenuItem, { value: "receiptDetails" }, "Receipt #"),
        React.createElement(MenuItem, { value: "orderOrigin" }, "Order Origin"),
        React.createElement(MenuItem, { value: "totalAmount" }, "Total"),
        React.createElement(MenuItem, { value: "accountIdUsed" }, "Payment")));
};
